






















































































































import { Component, Prop, Vue } from 'vue-property-decorator'
import { Form } from 'element-ui'
import { IProduct } from '@/api/types-client'
import { updateClientProduct } from '@/api/clients'
import { defaultProduct } from '@/store/modules/products'
import OrderTypeOption from '@/views/orders/components/OrderTypeOption.vue'

@Component({
  name: 'ProductEdit',
  components: {
    OrderTypeOption
  }
})
export default class extends Vue {
  @Prop({ default: false }) dialogVisible!: boolean;
  @Prop({ default: 0 }) clientId!: number;
  @Prop({ type: Object }) value!: IProduct;

  private productForm = Object.assign({}, defaultProduct)
  private loading = false
  private validateRequire = (rule: any, value: string, callback: Function) => {
    if (value === '') {
      callback(new Error(rule.field + ' is required'))
    } else {
      callback()
    }
  }

  private avmOptions = [
    { key: 0, name: 'None' },
    { key: 1, name: 'ValueLink Integration' },
    { key: 2, name: 'Manual Upload' }
  ]

  get getVendorId() {
    return this.clientId
  }

  private rules = {
    name: [{ validator: this.validateRequire }]
  }

  mounted() {
    this.productForm = Object.assign({}, this.value)
  }

  handleClose() {
    this.$emit('close', true)
  }

  async submitForm() {
    (this.$refs.productForm as Form).validate(async valid => {
      if (valid) {
        this.loading = true
        // console.log(`Saving Product. ${this.productForm.productId} ${this.productForm.clientId} ${this.productForm.orderTypeId}`)
        await updateClientProduct(this.productForm.clientId, this.productForm.productId, this.productForm)
        this.loading = false
        // console.log(`submitForm finished() ${this.productForm.clientId} `)
        this.$notify({
          title: 'Success',
          message: `Product ${this.productForm.productId} updated successfully.`,
          type: 'success',
          duration: 2000
        })
        this.dialogVisible = false
        this.handleClose()
        return true
      } else {
        console.log('Validation errors!')
      }
      this.loading = false
      return false
    })
  }

  cancelForm() {
    this.dialogVisible = false
  }
}
